"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useMutation } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";
import { toast } from "sonner";
import type { PremiumUpgradeDialogPhase } from "@/components/layouts/premium-upgrade/premium-upgrade-confirm-dialog";
import { isPremiumUpgradeRequestCooldownActive, writePremiumUpgradeRequestCooldown } from "@/components/layouts/premium-upgrade/premium-upgrade-request-storage";
import { useTierGuard } from "@/hooks/use-tier-guard";
import { useUserData } from "@/hooks/useUserData";
import { getActiveFreemiumTrialExpiresAt } from "@/lib/services/tier/tier-guard";
import { PricingTier } from "@/prisma/generated/enums";
import { requestPremiumUpgradeQuery } from "@/queries/organization/updates";
import { organizationMutationKeys } from "@/queries/query-keys/organization";
import { UserRole } from "@/types/user";
export function usePremiumUpgradeRequest() {
  const $ = _c(28);
  const {
    organization,
    userData
  } = useUserData();
  const {
    context,
    effectivePricingTier
  } = useTierGuard();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogPhase, setDialogPhase] = useState("confirm");
  const [cooldownUntil, setCooldownUntil] = useState(null);
  const [cooldownVersion, setCooldownVersion] = useState(0);
  const organizationId = organization?.id;
  let t0;
  bb0: {
    if (cooldownUntil) {
      if (new Date(cooldownUntil).getTime() > Date.now()) {
        t0 = true;
        break bb0;
      }
    }
    if (!organizationId) {
      t0 = false;
      break bb0;
    }
    let t1;
    if ($[0] !== organizationId) {
      t1 = isPremiumUpgradeRequestCooldownActive({
        organizationId
      });
      $[0] = organizationId;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const isCooldownActive = t0;
  const canRequestUpgrade = userData?.role === UserRole.ADMIN && effectivePricingTier !== PricingTier.PREMIUM && !isCooldownActive && Boolean(organizationId);
  let t1;
  if ($[2] !== context) {
    t1 = getActiveFreemiumTrialExpiresAt(context);
    $[2] = context;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const freemiumTrialExpiresAt = t1;
  let t2;
  if ($[4] !== organizationId) {
    t2 = organizationMutationKeys.requestPremiumUpgrade(organizationId);
    $[4] = organizationId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== organizationId) {
    t3 = result => {
      if (!organizationId) {
        return;
      }
      writePremiumUpgradeRequestCooldown({
        cooldownUntil: result.cooldownUntil,
        organizationId
      });
      setCooldownUntil(result.cooldownUntil);
      setDialogPhase("success");
      setCooldownVersion(_temp2);
    };
    $[6] = organizationId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: requestPremiumUpgradeQuery,
      mutationKey: t2,
      onError: _temp,
      onSuccess: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    isPending,
    mutate
  } = useMutation(t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setDialogPhase("confirm");
      setDialogOpen(true);
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const openUpgradeDialog = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setDialogOpen(false);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const closeUpgradeDialog = t6;
  let t7;
  if ($[13] !== isPending) {
    t7 = open => {
      if (isPending && !open) {
        return;
      }
      setDialogOpen(open);
      if (open) {
        setDialogPhase("confirm");
      }
    };
    $[13] = isPending;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleDialogOpenChange = t7;
  let t8;
  if ($[15] !== mutate || $[16] !== organizationId) {
    t8 = () => {
      if (!organizationId) {
        return;
      }
      mutate();
    };
    $[15] = mutate;
    $[16] = organizationId;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const confirmUpgrade = t8;
  let t9;
  if ($[18] !== canRequestUpgrade || $[19] !== confirmUpgrade || $[20] !== dialogOpen || $[21] !== dialogPhase || $[22] !== freemiumTrialExpiresAt || $[23] !== handleDialogOpenChange || $[24] !== isCooldownActive || $[25] !== isPending || $[26] !== organizationId) {
    t9 = {
      canRequestUpgrade,
      closeUpgradeDialog,
      confirmUpgrade,
      dialogOpen,
      dialogPhase,
      freemiumTrialExpiresAt,
      handleDialogOpenChange,
      isCooldownActive,
      isSubmitting: isPending,
      openUpgradeDialog,
      organizationId
    };
    $[18] = canRequestUpgrade;
    $[19] = confirmUpgrade;
    $[20] = dialogOpen;
    $[21] = dialogPhase;
    $[22] = freemiumTrialExpiresAt;
    $[23] = handleDialogOpenChange;
    $[24] = isCooldownActive;
    $[25] = isPending;
    $[26] = organizationId;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp2(version) {
  return version + 1;
}
function _temp(error) {
  const message = error instanceof Error ? error.message : "Could not send your request. Please try again.";
  toast.error("Could not send your request", {
    description: message
  });
}